import Pills from "../../../../components/controls/Pills";
import { convertStatus, formatDateWithTime } from "../../../../shared/utility";

export default function CustomerWorkOrdersTab(props) {
  const { workOrders } = props;
  return (
    <div>
      <h1 className="text-base font-semibold leading-6 text-gray-900">
        Work Orders
      </h1>

      <div className="overflow-hidden card-custom">
        <table className="min-w-full divide-y divide-gray-300">
          <thead className="bg-white">
            <tr>
              <th
                scope="col"
                className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
              >
                WO #
              </th>
              <th
                scope="col"
                className="px-3 py-3 text-left text-sm font-semibold text-gray-900"
              >
                Employee
              </th>
              <th
                scope="col"
                className="px-3 py-3 text-left text-sm font-semibold text-gray-900"
              >
                Start Date
              </th>
              <th
                scope="col"
                className="px-3 py-3 text-left text-sm font-semibold text-gray-900"
              >
                Status
              </th>
              <th scope="col" className="relative py-3 pl-3 pr-4 sm:pr-6"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {workOrders.length > 0 ? (
              workOrders.map((workOrder) => (
                <tr key={workOrder.id}>
                  <td className="whitespace-nowrap py-1.5 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                    {workOrder.work_number}
                  </td>
                  <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-700">
                    {workOrder.employee_name}
                  </td>
                  <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-700">
                    {formatDateWithTime(workOrder.start_date)}
                  </td>
                  <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-700">
                    <Pills content={convertStatus(workOrder.status)} />
                  </td>
                  <td className="relative whitespace-nowrap py-1.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a
                      className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      href={`/work-orders/${workOrder.id}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Edit
                    </a>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  className="whitespace-nowrap py-3 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 text-center"
                  colSpan={4}
                >
                  No Work Orders
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
